import { api } from "@/lib/api";

// Whole years from a YYYY-MM-DD date of birth.
export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age >= 0 && age < 130 ? age : null;
}

// The live backend derives age/sex-specific bloodwork ranges from /settings
// { age, sex }. It stores age (int), not a DOB, so we compute age here.
export async function saveHealthProfile({ dob, sex }) {
  const payload = {};
  const age = ageFromDob(dob);
  if (age != null) payload.age = age;
  if (sex) payload.sex = sex;
  if (Object.keys(payload).length === 0) return null;
  await api.put("/settings", payload);
  return payload;
}
